// Scroll-triggered entrance animations. All of the CSS hangs off classes
// this file sets:
//   .jwk-anim on <html> — the global switch. Not set with
//     prefers-reduced-motion or without IntersectionObserver, and never
//     present in the block editor or without JS, so none of the animation
//     CSS applies there.
//   .anim-block / .in-view on each block — .anim-block pauses every
//     animation inside the block on its first frame; .in-view (added once
//     the block is on screen) lets them play.
// Keyframes, the stagger index and the trigger CSS: the "Animations"
// <style> in index.html. What each block does: that block's own CSS in
// the jwk-portfolio plugin (core-block-styles.css, blocks/*/style.css).

const ENABLED =
  'IntersectionObserver' in window &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Set at import time — before app.js renders the header — so the header's
// load-in plays from its very first paint.
if (ENABLED) document.documentElement.classList.add('jwk-anim');

// Each of these starts on its own when it scrolls into view: every
// top-level block of a page, the rows inside the Skills block, the footer.
const BLOCKS = [
  '.wp-page > :not(style, script)',
  '.section-heading',
  '.skills-grid',
  '.technology-list',
  '#footer',
].join(',');

let observer = null;

// Called on every route:rendered (the router replaces #app wholesale).
// Blocks already set up are skipped, so the footer only animates once.
export function initAnimations(root = document) {
  if (!ENABLED) return;

  observer ??= new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15 }
  );

  const blocks = [...root.querySelectorAll(BLOCKS)].filter(
    (el) => !el.classList.contains('anim-block')
  );

  // All reads first, then all writes: one layout pass, not one per block.
  // Measured from the top of the document, because route:rendered fires
  // before the router's scrollTo(0, 0).
  const tops = blocks.map((el) => el.getBoundingClientRect().top + window.scrollY);
  const firstScreen = window.innerHeight;

  blocks.forEach((el, i) => {
    el.classList.add('anim-block');
    if (tops[i] < firstScreen) {
      // On the first screen already: start now rather than a frame later,
      // so the hero headline (LCP) paints as early as it did before.
      el.classList.add('in-view');
    } else {
      observer.observe(el);
    }
  });
}
